import { gql } from "@apollo/client"

export const GET_LAST_RESERVATION_FROM_ROOM = gql`
    query getLastReservaFromRoom($reserva_id: ID!) {
        reserva(reserva_id: $reserva_id) {
            reserva_id
            hospedajes_extra
            folio
            estado
            fecha_cancelacion
            fecha_salida
            fecha_entrada
            origen
            tipo_habitacion_id
            tipo_de_habitacion {
                nombre
            }
            habitacion_id
            habitacion {
                numero_habitacion
                habitacion_id
                tipo_habitacion {
                    nombre
                    personas_extra_max
                }
            }
            descuento_aplicado {
                data_descuento {
                    monto_calculado
                    tipo_descuento
                    valor
                }
                descuento {
                    nombre
                }
                descuento_id
                fecha_registro
                cancelado
            }
            extras {
                extra_id
                descuento_aplicado {
                    descuento_id
                    fecha_registro
                    data_descuento {
                        monto_calculado
                        tipo_descuento
                        valor
                    }
                    descuento {
                        nombre
                    }
                }
            }
            reservas_tarifas {
                fecha_fin
                fecha_inicio
                fecha_registro
                subtotales {
                    noches
                    precio_unitario
                    total
                    __typename
                }
                tarifa_id
                tarifa {
                    tarifa_id
                    nombre
                    tipo_alojamiento
                    costo_habitacion
                    costo_persona_extra
                    costo_hora_extra
                    costo_hospedaje_extra
                    costo_early_checkin
                    hora_checkin
                    hora_checkout
                    grupo_tarifa_id
                    grupo_tarifa {
                        nombre
                        grupo_tarifa_id
                        modalidad
                        __typename
                    }
                    __typename
                }
            __typename
            }
            correo_huesped
            nombre_huesped
            telefono_huesped
            numero_personas
            personas_extras
            usuario {
                nombre
            }
            estado_pago
            total
            pagos {
                pago_id
                total
                fecha_pago
                detalles_pago {
                    detalle_pago_id
                    subtotal
                    tipo_pago
                    ultimos_digitos
                    numero_referencia
                    easyrewards_id
                }
                extras {
                    monto_devuelto_cancelacion
                    fecha_cancelacion
                    fecha_pago
                    fecha_solicitud
                    monto_extra
                    motivo_cancelacion
                    numero
                    tipo_extra
                }
            }
            experiencias_reserva {
                experiencia_reserva_id
                experiencia_id
                total
                estado
                experiencia {
                    nombre
                }
            }
            comentarios {
                comentario
            }
        }
    }
`
